export default __webpack_public_path__ + "static/media/mode-536.f7bb88b4.svg";